@if (isLoading()) {
  <app-loader />
}

<router-outlet />

<app-alert-handler />
